import * as React from "react";
import { css, keyframes } from "emotion";
import { getThemeColorVar } from "../helper/color";
import classNames from "classnames";
const opacityKeyFrames = keyframes({
    "0%": { opacity: 1 },
    "100%": { opacity: 0.25 },
});
const loadingSpinnerOuterClassCentered = css({
    display: "inline-block",
    position: "relative",
    alignSelf: "center",
    verticalAlign: "top",
    left: "50%",
    transform: "translateX(-50%)",
});
const loadingSpinnerOuterClassLeft = css({
    display: "inline-block",
    position: "relative",
    alignSelf: "center",
    verticalAlign: "top",
});
const loadingSpinnerTickOuterClass = css({
    position: "absolute",
    left: 0,
    top: "50%",
});
function loadingSpinnerTickInnerClass(color, inverted) {
    const backgroundColor = color
        ? getThemeColorVar(color, inverted ? "inverted" : "default")
        : getThemeColorVar(inverted ? "white" : "black", undefined);
    return css({
        backgroundColor,
        position: "absolute",
        top: 0,
        bottom: 0,
        right: "10%",
        width: "25%",
        animation: `${opacityKeyFrames} 1s linear infinite`,
        transform: "translateZ(0)",
    });
}
const ticks = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
export const LoadingSpinner = (props) => {
    const size = props.size ? props.size : 80;
    const tickHeight = size / 20.0;
    const borderRadius = size / 40.0;
    const outerPos = (size - tickHeight) / 2.0;
    const angle = 360 / ticks.length;
    const duration = `${ticks.length}00ms`;
    return (React.createElement("div", { className: classNames("revo-loading-spinner", props.alignLeft
            ? loadingSpinnerOuterClassLeft
            : loadingSpinnerOuterClassCentered), style: { width: `${size}px`, height: `${size}px` } }, ticks.map((i) => (React.createElement("div", { key: i, className: loadingSpinnerTickOuterClass, style: {
            width: `${size}px`,
            height: `${tickHeight}px`,
            top: `${outerPos}px`,
            transform: `rotate(${-i * angle}deg)`,
        } },
        React.createElement("div", { className: loadingSpinnerTickInnerClass(props.color, props.inverted), style: {
                borderRadius: `${borderRadius}px`,
                animationDuration: duration,
                animationDelay: `-${i}00ms`,
            } }))))));
};
export default LoadingSpinner;
//# sourceMappingURL=loadingspinner.js.map